import React, { useContext, useState, useEffect , Component} from 'react'

export default function HomePageOffice() {
    return(
      <div>
         <br></br><br></br><br></br><br></br><br></br><br></br>
        HomePageOffice
      </div>
    )
  }